// v-safe-html — drop-in for v-html on user-authored rich text.
import { sanitizeHtml } from '@utils/sanitize';

export default {
  bind(el, { value }) {
    el.innerHTML = sanitizeHtml(value);
  },
  update(el, { value, oldValue }) {
    if (value !== oldValue) el.innerHTML = sanitizeHtml(value);
  },
};
